import {React} from 'react';
import LandingNav from './LandingNav';
 
function Landing() {
	
	return ( 
		<>
			<LandingNav/>
			<h1>Landing page content</h1>
		</>
	 );
}

export default Landing;